import i18n from 'modules/core/lib/i18n'

class FieldTranslations {
  t(field: string): string {
    switch (field) {
      case 'bank_number':
        return i18n.t('bookkeepers.incidence.details.bank_number')
      case 'first_name':
        return i18n.t('bookkeepers.incidence.details.first_name')
      case 'last_name':
        return i18n.t('bookkeepers.incidence.details.last_name')
      case 'gender':
        return i18n.t('bookkeepers.incidence.details.gender')
      case 'identifier':
        return i18n.t('bookkeepers.incidence.details.identifier')
      case 'identifier_type':
        return i18n.t('bookkeepers.incidence.details.identifier_type')
      case 'nationality':
        return i18n.t('bookkeepers.incidence.details.nationality')
      case 'start_date':
        return i18n.t('bookkeepers.incidence.details.start_date')
      case 'social_security_number':
        return i18n.t('bookkeepers.incidence.details.social_security_number')
      case 'email':
        return i18n.t('bookkeepers.incidence.details.email')
      case 'job_title':
        return i18n.t('bookkeepers.incidence.details.job_title')
      case 'city':
        return i18n.t('bookkeepers.incidence.details.city')
      case 'state':
        return i18n.t('bookkeepers.incidence.details.state')
      case 'postal_code':
        return i18n.t('bookkeepers.incidence.details.postal_code')
      case 'birthday_on':
        return i18n.t('bookkeepers.incidence.details.birthday_on')
      case 'address_line_1':
        return i18n.t('bookkeepers.incidence.details.address_line_1')
      case 'from':
        return i18n.t('bookkeepers.incidence.details.starts_on')
      case 'to':
        return i18n.t('bookkeepers.incidence.details.ends_on')
      case 'phone_number':
        return i18n.t('payroll_integrations.incidences.silae_api.unavailable_fields.phone_number')
      case 'company_code':
        return i18n.t('payroll_integrations.incidences.silae_api.unavailable_fields.company_code')
      case 'employee_identifier':
        return i18n.t(
          'payroll_integrations.incidences.silae_api.unavailable_fields.employee_company_identifier'
        )
      case 'location_code':
        return i18n.t('payroll_integrations.incidences.silae_api.unavailable_fields.location_code')
      case 'absence_code':
        return i18n.t('payroll_integrations.incidences.silae_api.unavailable_fields.absence_code')
      case 'siret':
        return i18n.t('payroll_integrations.incidences.silae_api.unavailable_fields.siret')
      default:
        return field
    }
  }
}

export default new FieldTranslations()
